import React from "react";
import {Col, FormGroup, Row} from "reactstrap";
import {useSelector} from "react-redux";
import {getSimUsageDetails} from "../../../../redux/Selectors/sim.selector";

function SimOverviewInformation(_props, ref) {
  const simUsageDetails = useSelector(getSimUsageDetails);
  const simUsageData = simUsageDetails ? simUsageDetails : {};
  React.useImperativeHandle(ref, () => {
    return {
      state: {},
    };
  });
  const {imsi = "", msisdn = "", status = ""} = simUsageData;
  return (
    <div className="pl-lg-4">
      <ul>
        <Row>
          <Col md="12">
            <li>
              <FormGroup>
                <label className="form-control-label " htmlFor="input-name">
                  IMSI:
                </label>
                <label
                  className="form-control-label sim-usage-label-value"
                  htmlFor="input-name"
                >
                  {imsi ? imsi : "NA"}
                </label>
              </FormGroup>
            </li>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <li>
              <FormGroup>
                <label className="form-control-label " htmlFor="input-name">
                  MSISDN:
                </label>
                <label
                  className="form-control-label sim-usage-label-value"
                  htmlFor="input-name"
                >
                  {msisdn ? msisdn : "NA"}
                </label>
              </FormGroup>
            </li>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <li>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-name">
                  STATUS:
                </label>
                <label
                  className="form-control-label sim-usage-label-value"
                  htmlFor="input-name"
                >
                  {status ? status : "NA"}
                </label>
              </FormGroup>
            </li>
          </Col>
        </Row>
      </ul>
    </div>
  );
}

export default React.forwardRef(SimOverviewInformation);
